import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';

export const canaryInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const baseUrl: string = inject(AppConfigService).appConfig.azure.proxy_base_url;
  const canary: string | undefined = inject(AppConfigService).appConfig.canary;

  if (request.url.includes(baseUrl)) {
    if (canary) {
      return next(
        request.clone({
          setHeaders: {
            'CV-Canary': canary,
          },
        })
      );
    }
  }

  return next(request);
};
